module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_vm._v("\n            Título\n          ")]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_vm._v("\n            Corpo\n          ")]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _vm._t("footer", function() {
    return [_vm._v("\n            Rodapé\n            "), _c('button', {
      staticClass: "modal-default-button",
      on: {
        "click": function($event) {
          return _vm.$emit('close')
        }
      }
    }, [_vm._v("\n              OK\n            ")])]
  })], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87b9f016"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/Modal.vue
// module id = 1462
// module chunks = 1